import Swiper from 'swiper';
import { Autoplay, EffectFade } from 'swiper/modules';

class TrustPilot {

  constructor(node) {
    if (node.nodeType !== Node.ELEMENT_NODE) return;
    this.root = node;
    this.swiper = this.root.querySelector('.TrustPilot .swiper');

    this._init();
  }

  _init() {

    Swiper.use([Autoplay, EffectFade]);

    new Swiper(this.swiper, {
      speed: 1300,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      // disable draggable
      allowTouchMove: false,
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      loop: true,
    });

  }
}

[...document.querySelectorAll('.TrustPilot')].forEach(node => {
  new TrustPilot(node);
});